import React from 'react';
import { usePlan } from '../../hooks/usePlan';
import { openPricingModal } from '../../utils/pricingModal';
import './waitlistBanner.css';

/**
 * Home banner shown only when the signed-in user's entitlement status is
 * 'waitlisted' (free tier is at cap, per docs/plans/2026-07-24-monetization-plan.md
 * §3.6). Visually styled like the app's dismissible tip callouts (see
 * common/dismissible.css) but deliberately carries NO dismiss control —
 * per spec this is not dismissible, since it reflects a real account state
 * the user needs to act on or wait out.
 */
function WaitlistBanner() {
  const { status, loading } = usePlan();

  if (loading || status !== 'waitlisted') {
    return null;
  }

  return (
    <div className="waitlist-banner" role="status">
      <span className="waitlist-banner__icon" aria-hidden="true">⏳</span>
      <p className="waitlist-banner__text">
        LinguaNewsCast free is currently full — you're on the waitlist. Upgrade to Plus to start now.
      </p>
      <button
        type="button"
        className="btn btn-primary waitlist-banner__cta"
        onClick={openPricingModal}
      >
        Upgrade
      </button>
    </div>
  );
}

export default WaitlistBanner;
